























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class NonRecurringDueDateControl extends Vue {
  // Props

  @Prop({ required: true })
  public value!: number;

  @Prop({ default: 0 })
  public minValue!: number;

  @Prop({ default: 90 })
  public maxValue!: number;
  // Computed
  public get dueDateDays() {
    return this.value;
  }
  public set dueDateDays(value) {
    this.$emit("input", value);
  }
  public get label() {
    return this.$tc(
      "_sentence.invoice.non_recurring_due_date_label",
      this.dueDateDays
    );
  }
  public get summary() {
    const dateTime = new Date();
    return this.$t("_sentence.invoice.non_recurring_due_date_summary", {
      startDate: this.$moment(dateTime).format("MMMM Do"),
      endDate: this.$moment(dateTime)
        .add(this.dueDateDays, "d")
        .format("MMMM Do")
    });
  }
}
